<template>
	<!-- Card -->
	<div class="wrapper-table-audit">
		<TableData
			:startLoad="table.startLoadTable()"
			:route="url"
			:settings="table.settings"
			:columns="tblColumns"
			:child="tblChild"
			childTableClass="table-bordered table-sm table-responsive-sm"
			:inlineFilters="tblFilters"
			:btnSearchFilters="false"
			:btnClearFilters="false"
			:titleData="null"
			tableWrapperClass="bg-lilac-light"
			tableClass="table-responsive-sm"
			@errorLoad="showError">
			<template v-slot:body="{fieldColumns, actionColumns, row, index, hasChild, childId}">
				<td v-for="(column, cIndex) in fieldColumns"
					:key="`group-${index}-column-${cIndex}`"
					:class="[column.class, column.field == 'event' ? `event-${row[column.field]}` : '']"
					v-html="columnValue(row, column)">
				</td>
				<template v-if="actionColumns.length">
					<ColumnActions :row="row" :index="index" >
						<li class="list-group-item"
							v-if="hasChild"
							role="button"
							data-toggle="collapse"
							aria-expanded="false"
							:data-target="`#${childId}`"
							:aria-controls="`${childId}`">
							<i class="fas fa-ellipsis action"
								data-toggle="tooltip-city"
								data-placement="left"
								:title="$t(`${idPanel}.list.actions.list-modified`)" />
						</li>
					</ColumnActions>
				</template>
			</template>

			<template v-slot:row-child="{row, columns, index, property, rowParent, indexParent}">
				<td v-for="(column, cIndex) in columns"
					:key="`group-${indexParent}-child-${index}-column-${cIndex}`"
					:class="column.class">
					<template v-if="column.field == 'key'">
						<span class="text-medium">
							<em>
								{{ $t(`${translatePrefix}.${rowParent?.model}.${property}`) }}
							</em>
						</span>
					</template>
					<template v-else-if="column.field in row">
						<ValueAudit
							:parentKeyBind="`group-${indexParent}-child-${index}-column-${cIndex}`"
							:value="row[column.field]" />
					</template>
					<template v-else>
						&nbsp;
					</template>
				</td>
			</template>
		</TableData>
	</div>
</template>

<script>
import ElementAuditMixin from '../mixins/ElementAuditMixin';

export default {
	name: 'TableAudit',
	mixins: [
		ElementAuditMixin
    ],
	components: {
		TableData: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "table-data" */ '@/app/shared/components/tables/DataTable'),
		ColumnActions: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "column-actions" */ '@/app/shared/components/tables/ColumnActions'),
		ValueAudit: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "audit-value" */ './../elements/ValueAudit'),
	},
	props: {
		columns: {
			type: Array,
			default: () => {return []},
		},
		filters: {
			type: Object,
			default: null,
		}
	},
	data() {
		return {
			idPanel: this.panelId,
			// labelDateFormat: 'DD/MM/YYYY',
			table: {
				startLoadTable: () => {return true;},
				settings: {
					sort: 'desc',
					order_by: 'created_at',
				},
			},
		}
	},
	computed: {
		defaultColumns() {
			return [
				{
					label: `${this.idPanel}.list.type`,
					field: 'model',
					// sortable: true,
					class: 'text-nowrap col-sm',
					func: (val, obj) => this.$t(`${this.translatePrefix}.models.${val}`, obj),
				},
				{
					label: `${this.idPanel}.list.event`,
					field: 'event',
					// sortable: true,
					class: 'text-nowrap text-center col-sm-4',
					func: (val) => this.$t(`${this.idPanel}.list.events.${val}`),
				},
				{
					label: `${this.idPanel}.list.user`,
					field: 'user.name',
					// sortable: true,
					class: 'col-sm text-center',
				},
				{
					label: `${this.idPanel}.list.created_at`,
					field: 'created_full',
					// sortable: true,
					class: 'text-nowrap text-center col-sm',
				},
				{
					label: '',
					field:  null,
					sortable: false,
					class: 'text-nowrap actions',
				}
			];
		},
		tblColumns() {
			return this.columns.length ? this.columns : this.defaultColumns;
		},
		tblChild() {
			return {
				property: 'data',
				columns: [
					{
						label: `${this.idPanel}.list.attribute`,
						field: 'key',
						class: '',
					},
					{
						label: (row) => this.$t(`${this.idPanel}.list.${row?.event}.old`),
						field: 'old',
						class: 'old',
					},
					{
						label: (row) => this.$t(`${this.idPanel}.list.${row?.event}.new`),
						field: 'new',
						class: 'new',
					},
				],
			};
		},
		tblFilters() {
			return this.filters ?? {};
		},
	},
	methods: {
		getModifiedAttribute(type, attribute, data) {
			return data?.attribute?.type ?? '';
		},
	},
	watch: {
	}
}
</script>

<style lang="scss">
.wrapper-table-audit  {
	.table {
		.event-created {
			color: #28a745;
		}
		.event-updated {
			color: #007bff;
		}
		.event-deleted {
			color: #dc3545;
		}
		.event-sync {
			color: #007bff;
		}

		.table-child {
			thead {
				tr th {
					padding: .3rem;
					box-shadow: inset 0 0 0 9999px rgba(0,0,0, 0.05);
				}
			}
			tbody {
				tr td {
					&.old {
						width: 50%;
						background: #ffe9e9;
					}
					&.new {
						width: 50%;
						background: #e9ffe9;
					}
				}
			}
		}
	}
}
</style>